import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateUserAccountSlice = getBulkActionSlice(
    'updateUserAccountResult',
);

export const selectUpdateUserAccountShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateUserAccountResult.shown;

export const selectUpdateUserAccountBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateUserAccountResult.uuid;

export const selectUpdateUserAccountTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateUserAccountResult.backgroundTask;


export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = updateUserAccountSlice.actions;
